// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'tax-bill-payment.page.title': 'Tax Bill Payments',
    'tax-bill-payment.page.search_results': 'Search Results',
    'tax-bill-payment.page.create.title': 'New Payment',
    'tax-bill-payment.page.search.title': 'Find Tax Bill Payments',
    'tax-bill-payment.page.edit.title': 'Edit Tax Bill Payment',
    'tax-bill-payment.page.view.title': 'View Tax Bill Payment',
    'tax-bill-payment.page.title.redo': 'Redo Payment',

    'tax-bill-payment.button.cancel': 'Cancel',
    'tax-bill-payment.button.select': 'Select',
    'tax-bill-payment.button.find': 'Find Tax Bill Payments',
    'tax-bill-payment.button.search': 'Apply',
    'tax-bill-payment.button.create': 'Record Payment',
    'tax-bill-payment.button.new': 'Record Payment',
    'tax-bill-payment.button.save': 'Save Changes',
    'tax-bill-payment.button.delete': 'Permanently Delete',
    'tax-bill-payment.button.edit': 'Edit',
    'tax-bill-payment.button.payments': 'Payment History',
    'tax-bill-payment.button.reset': 'Reset',
    'tax-bill-payment.button.void': 'Void Payment',
    'tax-bill-payment.button.refund': 'Refund Payment',
    'tax-bill-payment.button.rollback': 'Rollback Payment',
    'tax-bill-payment.button.redo': 'Redo',

    'tax-bill-payment.placeholder.search': 'Search tax bill payments',

    'tax-bill-payment.message.overpayment': 'Paying more than expected.',

    'tax-bill-payment.link.nothing-created': 'No payments made as yet',
    'tax-bill-payment.link.tax_bill_payments': ' Return to Tax Bill Payments',
    'tax-bill-payment.link.retry': 'Click here to retry',

    'tax-bill-payment.checkbox.all': 'Check All',
    'tax-bill-payment.checkbox.actions_label': 'with selected',

    'tax-bill-payment.label.tax_bill_name': 'Tax Bill',
    'tax-bill-payment.label.item': 'Item',
    'tax-bill-payment.label.balance': 'Balance',
    'tax-bill-payment.label.amount': 'Amount',
    'tax-bill-payment.label.total': 'Total',

    'tax-bill-payment.label.transaction_date': 'Transaction Date',
    'tax-bill-payment.label.bank_general_ledger_account_name': 'Bank Account',
    'tax-bill-payment.label.is_reconciled': 'Is Reconciled',
    'tax-bill-payment.label.payment_method': 'Payment Method',
    'tax-bill-payment.label.reference_code': 'Reference Code',
    'tax-bill-payment.label.memo': 'Memo',
    'tax-bill-payment.label.currency_name': 'Currency',
    'tax-bill-payment.label.currency_amount_in_cents': 'Amount',
    'tax-bill-payment.label.cancelled_on': 'Cancelled On',
    'tax-bill-payment.label.cancellation_reason': 'Cancellation Reason',
    'tax-bill-payment.label.status': 'Status',
    'tax-bill-payment.label.reason_for_void': 'Reason for voiding',
    'tax-bill-payment.label.rollback_reason': 'Reason for rollback',
    'tax-bill-payment.label.refund_reason': 'Reason for refund',

    'tax-bill-payment.sort.field_label': 'Field',
    'tax-bill-payment.sort.direction_label': 'Direction',
    'tax-bill-payment.sort.direction_ascending': 'Ascending',
    'tax-bill-payment.sort.direction_descending': 'Descending',

    'tax-bill-payment.modal.title.tax_bill_payment_delete_permanently': 'Delete Tax Bill Payment',
    'tax-bill-payment.modal.title.tax_bill_payment_restore': 'Restore Tax Bill Payment',
    'tax-bill-payment.modal.title.tax_bill_payment_void': 'Void Payment',
    'tax-bill-payment.modal.title.tax_bill_payment_refund': 'Refund Payment',
    'tax-bill-payment.modal.title.tax_bill_payment_rollback': 'Rollback Payment',

    'tax-bill-payment.modal.message.tax_bill_payment_delete_permanently':
        'Are you sure that you want to permanently delete this tax bill payment? This action cannot be undone. | Are you sure that you want to permanently delete these tax bill payments? This action cannot be undone.',
    'tax-bill-payment.modal.message.tax_bill_payment_restore': 'Are you sure that you want to restore this tax bill payment? | Are you sure that you want to restore these tax bill payments?',

    'tax-bill-payment.success.message.tax_bill_payment_created': 'Your tax bill payment has been created',
    'tax-bill-payment.success.message.tax_bill_payment_updated': 'Your tax bill payment has been updated',
    'tax-bill-payment.success.message.tax_bill_payment_restored': 'Your tax bill payment has been restored | All selected tax bill payments were restored',
    'tax-bill-payment.success.message.tax_bill_payment_deleted': 'Your tax bill payment has been permanently deleted | All selected tax bill payments were permanently deleted',
    'tax-bill-payment.success.message.tax_bill_payment_voided': 'Your tax bill payment has been voided',
    'tax-bill-payment.success.message.tax_bill_payment_refunded': 'Your tax bill payment has been refunded',
    'tax-bill-payment.success.message.tax_bill_payment_rolled_back': 'Your tax bill payment has been rolled back',
    'tax-bill-payment.success.message.tax_bill_payment_redone': 'Your tax bill payment has been redone',

    'tax-bill-payment.error.message.tax_bill_payment_deleted': 'This tax bill payment was already permanently deleted | These tax bill payments were already permanently deleted',
    'tax-bill-payment.error.message.tax_bill_payment_restored': 'This tax bill payment was already restored | These tax bill payments were already restored',
    'tax-bill-payment.error.message.error_loading_page': 'Sorry, there was an error loading tax bill payment.| Sorry, there was an error loading tax bill payments.',
};
